// extracted by mini-css-extract-plugin
export default {"container":"Button_container__K9X6Y","light":"Button_light__WvRrx","grey":"Button_grey__ZqTlR","dark":"Button_dark__LA9E9"};